import React, { useState, useEffect } from 'react';
import SignIn from '../components/SignIn';
import { useUser } from '../context/UserContext';
import SignOut from '../components/SignOut';
import { useNavigate } from "react-router-dom";
//
const SignInPage = () => {
  const { user, isLoggedIn } = useUser();
  const navigate = useNavigate();
  useEffect(() => {
    if (isLoggedIn){
    navigate("/");};
  }, [isLoggedIn]);
  return (
    <div style = {{height: "100vh"}}>
      {isLoggedIn ? (
        <div>
          
        </div>
      ) : (
        <div>
          <SignIn />
        </div>
      )}
    </div>
  );
};
export default SignInPage;

